import React from "react";
import { useTranslation } from "react-i18next";
import { HiOutlineLockClosed, HiOutlineQuestionMarkCircle } from "react-icons/hi2";
import { getDefaultPathForRole } from "../app/navigation";
import useAuth from "../hooks/useAuth";
import Button from "../ui/Button";

// Rendered inside the shell when a signed-in user opens a route their role
// may not use (direct URL, stale bookmark) or an unknown route. The
// navigation stays available so they can carry on working; signing out is
// not forced.
function NotPermitted({ notFound = false }) {
  const { t } = useTranslation();
  const { role } = useAuth();
  const home = getDefaultPathForRole(role);
  const Icon = notFound ? HiOutlineQuestionMarkCircle : HiOutlineLockClosed;
  const keyBase = notFound ? "shell.notFound" : "shell.notPermitted";

  return (
    <div className="mx-auto flex max-w-lg flex-col items-center px-4 py-16 text-center" data-testid={notFound ? "not-found" : "not-permitted"}>
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-amber-50 text-amber-600">
        <Icon size={28} aria-hidden="true" />
      </span>
      <h1 className="mt-5 text-xl font-semibold text-slate-900">{t(`${keyBase}.title`)}</h1>
      <p className="mt-2 text-sm leading-6 text-slate-500">{t(`${keyBase}.description`)}</p>
      {home !== "/login" ? (
        <Button to={home} className="mt-6">
          {t("shell.notPermitted.goHome")}
        </Button>
      ) : null}
    </div>
  );
}

export default NotPermitted;
